export default {
    props:["showMiniLoader", "successMiniLoader","failMiniLoader"]
}